var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import * as L from "leaflet";
import { Icon, Marker, Rectangle, Polygon, Draggable, DomEvent, Util, DomUtil, Handler, Evented, Polyline, LineUtil, latLng } from "leaflet";
const defaultIconSrc = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25.1" height="40.227">\n	<defs>\n		<linearGradient id="b">\n			<stop offset="0" stop-color="${color1}" />\n			<stop offset="1" stop-color="${color2}" />\n		</linearGradient>\n		<linearGradient id="a">\n			<stop offset="0" stop-color="${color3}" />\n			<stop offset="1" stop-color="${color4}" />\n		</linearGradient>\n		<linearGradient xlink:href="#a" id="c" gradientUnits="userSpaceOnUse"\n			gradientTransform="translate(-432.796 -503.349)" x1="445.301" y1="541.286" x2="445.301" y2="503.72" />\n		<linearGradient xlink:href="#b" id="d" gradientUnits="userSpaceOnUse"\n			gradientTransform="translate(-341.216 -503.35)" x1="351.748" y1="522.774" x2="351.748" y2="503.721" />\n	</defs>\n	<path fill="#fff" d="M6.329 4.513h12.625v14.5H6.329z" />\n	<path\n		d="M12.594.55C6.021.55.55 6.241.55 12.416c0 2.778 1.564 6.308 2.694 8.746l9.306 17.872 9.262-17.872c1.13-2.438 2.738-5.791 2.738-8.746C24.55 6.241 19.167.55 12.594.55zm0 7.155a4.714 4.714 0 0 1 4.679 4.71c0 2.588-2.095 4.663-4.679 4.679-2.584-.017-4.679-2.09-4.679-4.679a4.714 4.714 0 0 1 4.679-4.71z"\n		fill="url(#c)" stroke="url(#d)" stroke-width="1.1" stroke-linecap="round" />\n	<path\n		d="M12.581 1.657c-5.944 0-10.938 5.219-10.938 10.75 0 2.359 1.443 5.832 2.563 8.25l.031.031 8.313 15.969 8.25-15.969.031-.031c1.135-2.448 2.625-5.706 2.625-8.25 0-5.538-4.931-10.75-10.875-10.75zm0 4.969c3.168.021 5.781 2.601 5.781 5.781 0 3.18-2.613 5.761-5.781 5.781-3.168-.02-5.75-2.61-5.75-5.781 0-3.172 2.582-5.761 5.75-5.781z"\n		stroke="#fff" stroke-width="1.1" stroke-linecap="round" stroke-opacity=".122" fill="none" />\n</svg>';
const plusIconSrc = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">\n	<g transform="matrix(.02604 0 0 .02604 1.302 1.302)" fill="none" stroke="#000" opacity="0.3">\n		<circle cx="410.9" cy="410.9" r="410.9" color="#000" overflow="visible" stroke-width="100" />\n		<path d="M410.9 223.2v375.4M598.6 410.9H223.2" stroke-width="120" stroke-linecap="round" />\n	</g>\n</svg>';
const markerShadowUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC";
function createSvgDataUrl(src) {
  return `data:image/svg+xml;base64,${btoa(src)}`;
}
function createDefaultMarkerIconSrc(colors) {
  let src = defaultIconSrc;
  for (const key of Object.keys(colors)) {
    src = src.replace(new RegExp(`\\$\\{${key}\\}`, "g"), colors[key]);
  }
  return src;
}
function createDefaultMarkerIcon(colors) {
  const url = createSvgDataUrl(createDefaultMarkerIconSrc(colors));
  return new Icon.Default({
    // Icon.Default uses `this.options.imagePath || IconDefault.imagePath` as the prefix for the icon URL.
    // new String('') is an empty string that is truthy, resulting in an empty prefix (which we want for the data URL).
    imagePath: new String(""),
    iconUrl: url,
    iconRetinaUrl: url,
    shadowUrl: markerShadowUrl
  });
}
const defaultIcon = createDefaultMarkerIcon({ color1: "#2e6c97", color2: "#3883b7", color3: "#126fc6", color4: "#4c9cd1" });
const startIcon = createDefaultMarkerIcon({ color1: "#2E9749", color2: "#06EA3F", color3: "#03D337", color4: "#40DD68" });
const endIcon = createDefaultMarkerIcon({ color1: "#972E2E", color2: "#B73838", color3: "#C61212", color4: "#D14C4C" });
const plusIcon = new Icon({
  iconUrl: createSvgDataUrl(plusIconSrc),
  iconSize: [24, 24],
  iconAnchor: [12, 12]
});
function matchesLayerFilter(layer, filter, ...args) {
  if (typeof filter === "function")
    return filter(layer, ...args);
  else if (typeof filter === "boolean")
    return filter;
  else if (Array.isArray(filter))
    return filter.includes(layer);
  else
    return filter === layer;
}
function locateOnLine(map, trackPoints, points, isPolygon = false) {
  const isFlat = L.LineUtil.isFlat(trackPoints);
  let normalizedTrackPoints = isFlat ? [trackPoints] : trackPoints;
  if (!normalizedTrackPoints.some((t) => t.length >= 2)) {
    throw new Error("Line doesn't have any track points.");
  }
  if (isPolygon) {
    normalizedTrackPoints = normalizedTrackPoints.map((trackPoints2) => [...trackPoints2, trackPoints2[0]]);
  }
  let maxzoom = map.getMaxZoom();
  if (maxzoom === Infinity) {
    maxzoom = map.getZoom();
  }
  const projectedPoints = (Array.isArray(points) ? points : [points]).map((point) => map.project(point, maxzoom));
  const data = [];
  for (let i = 0; i < normalizedTrackPoints.length; i++) {
    let pointA;
    let pointB = map.project(normalizedTrackPoints[i][0], maxzoom);
    for (let j = 1; j < normalizedTrackPoints[i].length; j++) {
      pointA = pointB;
      pointB = map.project(normalizedTrackPoints[i][j], maxzoom);
      for (let k = 0; k < projectedPoints.length; k++) {
        const point = projectedPoints[k];
        const sqDist = L.LineUtil._sqClosestPointOnSegment(point, pointA, pointB, true);
        if (data[k] == null || sqDist < data[k].sqDist) {
          data[k] = { sqDist, idx: [i, j - 1], point, pointA, pointB };
        }
      }
    }
  }
  const results = data.map((d) => {
    const closest = L.LineUtil.closestPointOnSegment(d.point, d.pointA, d.pointB);
    const segDist = d.pointB.distanceTo(d.pointA);
    const idx = [d.idx[0], d.idx[1] + (segDist === 0 ? 0.5 : closest.distanceTo(d.pointA) / segDist)];
    return {
      idx: isFlat ? idx[1] : idx,
      closest: map.unproject(closest, maxzoom)
    };
  });
  return Array.isArray(points) ? results : results[0];
}
function getRouteInsertPosition(map, routePoints, trackPoints, point) {
  let pointIndex;
  let routePointIndexes;
  if (typeof routePoints[0] === "number") {
    pointIndex = typeof point === "number" ? point : locateOnLine(map, trackPoints, point).idx;
    routePointIndexes = routePoints;
  } else if (typeof point === "number") {
    pointIndex = point;
    routePointIndexes = locateOnLine(map, trackPoints, routePoints).map((r) => r.idx);
  } else {
    [pointIndex, ...routePointIndexes] = locateOnLine(map, trackPoints, [point, ...routePoints]).map((r) => r.idx);
  }
  for (let i = 1; i < routePointIndexes.length; i++) {
    if (routePointIndexes[i] > pointIndex)
      return i;
  }
  return routePointIndexes.length - 1;
}
function getFromPosition(arr, idx) {
  return Array.isArray(idx) ? arr[idx[0]][idx[1]] : arr[idx];
}
function insertAtPosition(arr, item, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), item, ...arr.slice(idxArr[0])];
  } else {
    const result = [...arr];
    result[idxArr[0]] = insertAtPosition(result[idxArr[0]], item, idxArr.slice(1));
    return result;
  }
}
function updateAtPosition(arr, item, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), item, ...arr.slice(idxArr[0] + 1)];
  } else {
    const result = [...arr];
    result[idxArr[0]] = updateAtPosition(result[idxArr[0]], item, idxArr.slice(1));
    return result;
  }
}
function removeFromPosition(arr, idx) {
  const idxArr = Array.isArray(idx) ? idx : [idx];
  if (idxArr.length === 0) {
    return arr;
  } else if (idxArr.length === 1) {
    return [...arr.slice(0, idxArr[0]), ...arr.slice(idxArr[0] + 1)];
  } else {
    const result = [...arr];
    result[idxArr[0]] = removeFromPosition(result[idxArr[0]], idxArr.slice(1));
    return result;
  }
}
function setPoint(layer, point, idx, insert) {
  if (layer instanceof L.Rectangle) {
    const i = Array.isArray(idx) ? idx[1] : idx;
    const bounds = layer.getBounds();
    if (i === 0) {
      layer.setBounds(L.latLngBounds([Math.min(point.lat, bounds.getNorth()), Math.min(point.lng, bounds.getEast())], bounds.getNorthEast()));
    } else if (i === 1) {
      layer.setBounds(L.latLngBounds([Math.max(point.lat, bounds.getSouth()), Math.min(point.lng, bounds.getEast())], bounds.getSouthEast()));
    } else if (i === 2) {
      layer.setBounds(L.latLngBounds([Math.max(point.lat, bounds.getSouth()), Math.max(point.lng, bounds.getWest())], bounds.getSouthWest()));
    } else if (i === 3) {
      layer.setBounds(L.latLngBounds([Math.min(point.lat, bounds.getNorth()), Math.max(point.lng, bounds.getWest())], bounds.getNorthWest()));
    }
    return;
  }
  const hasRoutePoints = layer.hasDraggableLinesRoutePoints();
  let points = hasRoutePoints ? layer.getDraggableLinesRoutePoints() : layer.getLatLngs();
  if (insert)
    points = insertAtPosition(points, point, idx);
  else
    points = updateAtPosition(points, point, idx);
  if (hasRoutePoints)
    layer.setDraggableLinesRoutePoints(points);
  else
    layer.setLatLngs(points);
}
function removePoint(layer, idx) {
  if (layer instanceof L.Rectangle) {
    return;
  }
  const hasRoutePoints = layer.hasDraggableLinesRoutePoints();
  let points = hasRoutePoints ? layer.getDraggableLinesRoutePoints() : layer.getLatLngs();
  points = removeFromPosition(points, idx);
  if (hasRoutePoints)
    layer.setDraggableLinesRoutePoints(points);
  else
    layer.setLatLngs(points);
}
function getPlusIconPoint(map, trackPoints, distance, atStart) {
  const tr = atStart ? trackPoints : [...trackPoints].reverse();
  const point0 = map.latLngToContainerPoint(tr[0]);
  const tr1 = tr.find((p, i) => i > 0 && point0.distanceTo(map.latLngToContainerPoint(p)) > 0);
  let result;
  if (!tr1) {
    result = L.point(point0.x + (atStart ? -1 : 1) * distance, point0.y);
  } else {
    const point1 = map.latLngToContainerPoint(tr1);
    const fraction = distance / point0.distanceTo(point1);
    result = L.point(point0.x - fraction * (point1.x - point0.x), point0.y - fraction * (point1.y - point0.y));
  }
  return map.containerPointToLatLng(result);
}
class DraggableLinesMarker extends Marker {
  constructor(draggable, layer, latlng, isInsert, options) {
    super(latlng, options);
    __publicField(this, "_draggable");
    __publicField(this, "_layer");
    __publicField(this, "_isInsert");
    __publicField(this, "_dragIdx");
    __publicField(this, "_dragFrom");
    this._draggable = draggable;
    this._layer = layer;
    this._isInsert = isInsert;
  }
  onAdd(map) {
    super.onAdd(map);
    this.on("dragstart", this.handleDragStart, this);
    this.on("drag", this.handleDrag, this);
    this.on("dragend", this.handleDragEnd, this);
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    return this;
  }
  handleDragStart(e) {
    const latlng = this.getLatLng();
    this._dragFrom = latlng;
    this._dragIdx = this.getIdx();
    setPoint(this._layer, latlng, this._dragIdx, this._isInsert);
    this._draggable.fire("dragstart", { layer: this._layer, from: latlng, to: latlng, idx: this._dragIdx, isNew: this._isInsert });
  }
  handleDrag() {
    const latlng = this.getLatLng();
    setPoint(this._layer, latlng, this._dragIdx, false);
    this._draggable.fire("drag", { layer: this._layer, from: this._dragFrom, to: latlng, idx: this._dragIdx, isNew: this._isInsert });
  }
  handleDragEnd() {
    const event = { layer: this._layer, from: this._dragFrom, to: this.getLatLng(), idx: this._dragIdx, isNew: this._isInsert };
    Promise.resolve().then(() => {
      setPoint(event.layer, event.to, event.idx, false);
      this._draggable.fire("dragend", event);
    });
  }
}
class DraggableLinesDragMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, idx, options, removeOnClick) {
    super(draggable, layer, latlng, false, {
      draggable: true,
      ...options
    });
    __publicField(this, "_idx");
    __publicField(this, "_removeOnClick");
    __publicField(this, "_over", false);
    this._idx = idx;
    this._removeOnClick = removeOnClick;
  }
  onAdd(map) {
    super.onAdd(map);
    const latlngs = this._layer.getDraggableLinesRoutePoints() || this._layer.getLatLngs();
    const points = Array.isArray(this._idx) ? latlngs[this._idx[0]] : latlngs;
    if (this._removeOnClick && !(this._layer instanceof Rectangle) && points.length > (this._layer instanceof Polygon ? 3 : 2)) {
      this.on("click", this.handleClick);
    }
    this.on("mouseover", () => {
      if (Draggable._dragging)
        return;
      this._over = true;
      this._draggable.fire("dragmouseover", { layer: this._layer, idx: this._idx, marker: this });
    });
    this.on("mouseout", () => {
      if (Draggable._dragging)
        return;
      this._over = false;
      this._draggable.fire("dragmouseout", { layer: this._layer, idx: this._idx, marker: this });
    });
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    if (this._over)
      this._draggable.fire("dragmouseout", { layer: this._layer, idx: this._idx, marker: this });
    return this;
  }
  getIdx() {
    return this._idx;
  }
  handleClick() {
    const idx = this.getIdx();
    removePoint(this._layer, idx);
    this._draggable.fire("remove", { layer: this._layer, idx });
  }
}
function createIcon(layer, baseIcon) {
  const icon = Util.create(baseIcon);
  const _setIconStyles = icon._setIconStyles;
  icon._setIconStyles = (img, name) => {
    _setIconStyles.call(icon, img, name);
    const padding = layer.options.weight * 2;
    img.style.padding = `${padding}px`;
    img.style.boxSizing = "content-box";
    img.style.marginLeft = `${parseInt(img.style.marginLeft) - padding}px`;
    img.style.marginTop = `${parseInt(img.style.marginTop) - padding}px`;
    img.style.display = "none";
  };
  return icon;
}
class DraggableLinesTempMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, options) {
    super(draggable, layer, latlng, true, {
      draggable: true,
      zIndexOffset: -1e5,
      ...options,
      icon: createIcon(layer, options.icon)
    });
    __publicField(this, "renderPoint");
  }
  onAdd(map) {
    super.onAdd(map);
    map.on("mousemove", this.handleMapMouseMove, this);
    DomEvent.on(map.getContainer(), "mouseover", this.handleMapMouseOver, this);
    this.on("click", this.handleClick, this);
    this.updateLatLng(this.getLatLng());
    return this;
  }
  onRemove(map) {
    if (!this.isHidden())
      this.fireMouseOut();
    super.onRemove(map);
    map.off("mousemove", this.handleMapMouseMove, this);
    DomEvent.off(map.getContainer(), "mouseover", this.handleMapMouseOver, this);
    return this;
  }
  show() {
    this._icon.style.display = "";
    if (this._shadow)
      this._shadow.style.display = "";
    this.fireMouseOver();
  }
  hide() {
    this._icon.style.display = "none";
    if (this._shadow)
      this._shadow.style.display = "none";
    this.fireMouseOut();
  }
  isHidden() {
    return this._icon.style.display == "none";
  }
  getIdx() {
    if (!this.renderPoint) {
      throw new Error("renderPoint is not set");
    }
    return this.renderPoint.idx;
  }
  handleClick() {
    if (!this.renderPoint) {
      return;
    }
    const latlng = this.renderPoint.closest;
    const idx = this.renderPoint.idx;
    setPoint(this._layer, latlng, idx, true);
    this._draggable.fire("insert", { layer: this._layer, latlng, idx });
  }
  shouldRemove(mouseLatlng) {
    return !this._layer._containsPoint(this._map.latLngToLayerPoint(mouseLatlng));
  }
  // Overridden by DraggableLinesPlusTempMarker
  getRenderPoint(mouseLatLng) {
    const loc = locateOnLine(this._map, this._layer.getLatLngs(), mouseLatLng, this._layer instanceof Polygon);
    const distancePx = this._map.project(mouseLatLng).distanceTo(this._map.project(loc.closest));
    if (distancePx > this._layer.options.weight / 2 + 1)
      return void 0;
    let idx = this._layer.hasDraggableLinesRoutePoints() ? getRouteInsertPosition(this._map, this._draggable._getRoutePointIndexes(this._layer), this._layer.getLatLngs(), loc.idx) : Array.isArray(loc.idx) ? [loc.idx[0], Math.ceil(loc.idx[1])] : Math.ceil(loc.idx);
    return {
      closest: loc.closest,
      idx
    };
  }
  updateLatLng(mouseLatLng) {
    if (Draggable._dragging)
      return false;
    if (this.shouldRemove(mouseLatLng)) {
      this.remove();
      return false;
    }
    this.renderPoint = this.getRenderPoint(mouseLatLng);
    if (this.renderPoint)
      this.setLatLng(this.renderPoint.closest);
    const isVisible = !this.isHidden();
    if (this.renderPoint && !isVisible)
      this.show();
    else if (!this.renderPoint && isVisible)
      this.hide();
    else if (isVisible)
      this.fireMouseMove();
  }
  handleMapMouseMove(e) {
    this.updateLatLng(this._map.mouseEventToLatLng(e.originalEvent));
  }
  handleMapMouseOver(e) {
    if (!Draggable._dragging && e.target !== this.getElement() && e.target !== this._layer.getElement())
      this.remove();
  }
  fireMouseOver() {
    this._draggable.fire("tempmouseover", { layer: this._layer, idx: this.getIdx(), marker: this, latlng: this.getLatLng() });
  }
  fireMouseMove() {
    this._draggable.fire("tempmousemove", { layer: this._layer, idx: this.getIdx(), marker: this, latlng: this.getLatLng() });
  }
  fireMouseOut() {
    this._draggable.fire("tempmouseout", { layer: this._layer, marker: this });
  }
}
class DraggableLinesPlusMarker extends DraggableLinesMarker {
  constructor(draggable, layer, latlng, idx, options, tempMarkerOptions) {
    super(draggable, layer, latlng, true, {
      pane: "overlayPane",
      zIndexOffset: -2e5,
      ...options
    });
    __publicField(this, "_idx");
    __publicField(this, "_tempMarker");
    __publicField(this, "_tempMarkerOptions");
    this._idx = idx;
    this._tempMarkerOptions = tempMarkerOptions;
  }
  onAdd(map) {
    super.onAdd(map);
    this.on("mouseover", this.handleMouseOver, this);
    return this;
  }
  onRemove(map) {
    super.onRemove(map);
    if (this._tempMarker) {
      this._tempMarker.remove();
      delete this._tempMarker;
    }
    return this;
  }
  getIdx() {
    return this._idx;
  }
  handleMouseOver(e) {
    this._draggable.removeTempMarker();
    this._tempMarker = new DraggableLinesPlusTempMarker(this._draggable, this._layer, this, e.latlng, this.getIdx(), this._tempMarkerOptions).addTo(this._map);
    this._draggable._tempMarker = this._tempMarker;
  }
}
class DraggableLinesPlusTempMarker extends DraggableLinesTempMarker {
  constructor(draggable, layer, plusMarker, latlng, idx, options) {
    super(draggable, layer, latlng, options);
    __publicField(this, "_plusMarker");
    __publicField(this, "_idx");
    this._plusMarker = plusMarker;
    this._idx = idx;
  }
  shouldRemove(latlng) {
    const layerPoint = this._map.latLngToLayerPoint(latlng);
    const position = DomUtil.getPosition(this._plusMarker._icon);
    return Math.abs(position.y - layerPoint.y) > this._plusMarker._icon.offsetHeight / 2 || Math.abs(position.x - layerPoint.x) > this._plusMarker._icon.offsetWidth / 2;
  }
  getRenderPoint() {
    return { idx: this._idx, closest: this.getLatLng() };
  }
  fireMouseOver() {
    this._draggable.fire("plusmouseover", { layer: this._layer, idx: this.getIdx(), marker: this, plusMarker: this._plusMarker });
  }
  fireMouseMove() {
  }
  fireMouseOut() {
    this._draggable.fire("plusmouseout", { layer: this._layer, idx: this.getIdx(), marker: this, plusMarker: this._plusMarker });
  }
}
class DraggableLinesHandler extends (() => {
  function HandlerAndEvented(map) {
    Handler.call(this, map);
  }
  Object.setPrototypeOf(HandlerAndEvented.prototype, Handler.prototype);
  Object.assign(HandlerAndEvented.prototype, Evented.prototype);
  return HandlerAndEvented;
})() {
  constructor(map, options) {
    super(map);
    __publicField(this, "options");
    __publicField(this, "_tempMarker");
    __publicField(this, "handleLayerAdd", (e) => {
      if (e.layer instanceof Polyline && this.shouldEnableForLayer(e.layer))
        this.enableForLayer(e.layer);
    });
    __publicField(this, "handleLayerRemove", (e) => {
      if (e.layer instanceof Polyline)
        this.disableForLayer(e.layer);
    });
    __publicField(this, "handleLayerMouseOver", (e) => {
      if (Draggable._dragging)
        return;
      this.drawTempMarker(e.target, e.latlng);
    });
    __publicField(this, "handleLayerSetLatLngs", (e) => {
      const layer = e.target;
      if (!Draggable._dragging || e.target instanceof Rectangle) {
        this.removeTempMarker();
        if (layer._draggableLines) {
          layer._draggableLines.routePointIndexes = void 0;
          this.drawDragMarkers(layer);
          this.drawPlusMarkers(layer);
        }
      }
    });
    this.options = {
      enableForLayer: (layer) => layer.options.interactive,
      allowDraggingLine: true,
      allowExtendingLine: true,
      removeOnClick: true,
      ...options
    };
  }
  addHooks() {
    this._map.on("layeradd", this.handleLayerAdd);
    this._map.on("layerremove", this.handleLayerRemove);
    this._map.eachLayer((layer) => {
      this.handleLayerAdd({ layer });
    });
  }
  removeHooks() {
    this._map.off("layeradd", this.handleLayerAdd);
    this._map.off("layerremove", this.handleLayerRemove);
    this._map.eachLayer((layer) => {
      this.handleLayerRemove({ layer });
    });
  }
  shouldEnableForLayer(layer) {
    return matchesLayerFilter(layer, this.options.enableForLayer);
  }
  drawDragMarkers(layer) {
    var _a, _b, _c, _d;
    if (!layer._draggableLines)
      return;
    if (layer instanceof Rectangle) {
      const bounds = layer.getBounds();
      const latLngs = [bounds.getSouthWest(), bounds.getNorthWest(), bounds.getNorthEast(), bounds.getSouthEast()];
      for (let i = 0; i < latLngs.length; i++) {
        if (layer._draggableLines.dragMarkers[i]) {
          layer._draggableLines.dragMarkers[i].setLatLng(latLngs[i]);
        } else {
          layer._draggableLines.dragMarkers[i] = new DraggableLinesDragMarker(this, layer, latLngs[i], i, {
            icon: defaultIcon,
            ...(_b = (_a = this.options).dragMarkerOptions) == null ? void 0 : _b.call(_a, layer, i, latLngs.length)
          }, false).addTo(this._map);
        }
      }
      return;
    }
    this.removeDragMarkers(layer);
    const latlngs = layer.getDraggableLinesRoutePoints() || layer.getLatLngs();
    const routePoints = LineUtil.isFlat(latlngs) ? [latlngs] : latlngs;
    const isFlat = LineUtil.isFlat(latlngs);
    for (let i = 0; i < routePoints.length; i++) {
      for (let j = 0; j < routePoints[i].length; j++) {
        const idx = isFlat ? j : [i, j];
        let removeOnClick = matchesLayerFilter(layer, this.options.removeOnClick, idx);
        const options = {
          icon: layer instanceof Polygon ? defaultIcon : j == 0 ? startIcon : j == routePoints[i].length - 1 ? endIcon : defaultIcon,
          ...(_d = (_c = this.options).dragMarkerOptions) == null ? void 0 : _d.call(_c, layer, j, routePoints[i].length)
        };
        const marker = new DraggableLinesDragMarker(this, layer, routePoints[i][j], idx, options, removeOnClick).addTo(this._map);
        layer._draggableLines.dragMarkers.push(marker);
      }
    }
  }
  removeDragMarkers(layer) {
    if (!layer._draggableLines)
      return;
    for (const marker of layer._draggableLines.dragMarkers) {
      marker.removeFrom(this._map);
    }
    layer._draggableLines.dragMarkers = [];
  }
  drawPlusMarkers(layer) {
    var _a, _b, _c, _d;
    this.removePlusMarkers(layer);
    if (layer instanceof Polygon || !layer._draggableLines || !matchesLayerFilter(layer, this.options.allowExtendingLine))
      return;
    const latlngs = layer.getLatLngs();
    const trackPoints = LineUtil.isFlat(latlngs) ? [latlngs] : latlngs;
    const routePoints = layer.getDraggableLinesRoutePoints();
    for (let i = 0; i < trackPoints.length; i++) {
      if (trackPoints[i].length < 2)
        continue;
      for (const isStart of [true, false]) {
        let idx;
        if (routePoints)
          idx = isStart ? 0 : routePoints.length;
        else if (LineUtil.isFlat(latlngs))
          idx = isStart ? 0 : trackPoints[i].length;
        else
          idx = isStart ? [i, 0] : [i, trackPoints[i].length];
        const options = {
          icon: plusIcon,
          ...(_b = (_a = this.options).plusMarkerOptions) == null ? void 0 : _b.call(_a, layer, isStart)
        };
        const tempMarkerOptions = {
          icon: isStart ? startIcon : endIcon,
          ...(_d = (_c = this.options).plusTempMarkerOptions) == null ? void 0 : _d.call(_c, layer, isStart)
        };
        const marker = new DraggableLinesPlusMarker(this, layer, getPlusIconPoint(this._map, trackPoints[i], 24 + layer.options.weight / 2, isStart), idx, options, tempMarkerOptions).addTo(this._map);
        layer._draggableLines.plusMarkers.push(marker);
      }
    }
  }
  removePlusMarkers(layer) {
    if (!layer._draggableLines)
      return;
    for (const marker of layer._draggableLines.plusMarkers) {
      marker.removeFrom(this._map);
    }
    layer._draggableLines.plusMarkers = [];
  }
  drawTempMarker(layer, latlng) {
    var _a, _b;
    this.removeTempMarker();
    if (layer instanceof Rectangle || !matchesLayerFilter(layer, this.options.allowDraggingLine)) {
      return;
    }
    const options = {
      icon: defaultIcon,
      ...(_b = (_a = this.options).tempMarkerOptions) == null ? void 0 : _b.call(_a, layer)
    };
    this._tempMarker = new DraggableLinesTempMarker(this, layer, latlng, options).addTo(this._map);
  }
  removeTempMarker() {
    if (this._tempMarker) {
      this._tempMarker.removeFrom(this._map);
      delete this._tempMarker;
    }
  }
  enableForLayer(layer) {
    if (layer._draggableLines)
      return;
    layer._draggableLines = {
      dragMarkers: [],
      plusMarkers: [],
      zoomEndHandler: () => {
        this.drawPlusMarkers(layer);
      },
      routePointIndexes: void 0
    };
    layer.on("mouseover", this.handleLayerMouseOver);
    layer.on("draggableLines-setLatLngs", this.handleLayerSetLatLngs);
    layer.on("draggableLines-setRoutePoints", this.handleLayerSetLatLngs);
    this._map.on("zoomend", layer._draggableLines.zoomEndHandler);
    this.drawDragMarkers(layer);
    this.drawPlusMarkers(layer);
  }
  redrawForLayer(layer) {
    if (!layer._draggableLines)
      return;
    this.drawDragMarkers(layer);
    this.drawPlusMarkers(layer);
    if (this._tempMarker && this._tempMarker._layer === layer)
      this.drawTempMarker(layer, this._tempMarker.getLatLng());
  }
  disableForLayer(layer) {
    layer.off("mouseover", this.handleLayerMouseOver);
    layer.off("draggableLines-setLatLngs", this.handleLayerSetLatLngs);
    layer.off("draggableLines-setRoutePoints", this.handleLayerSetLatLngs);
    if (layer._draggableLines)
      this._map.off("zoomend", layer._draggableLines.zoomEndHandler);
    this.removeDragMarkers(layer);
    this.removePlusMarkers(layer);
    delete layer._draggableLines;
  }
  redraw() {
    this._map.eachLayer((layer) => {
      if (!(layer instanceof Polyline))
        return;
      const enable = this.shouldEnableForLayer(layer);
      if (layer._draggableLines && !enable)
        this.disableForLayer(layer);
      else if (!layer._draggableLines && enable)
        this.enableForLayer(layer);
      else if (layer._draggableLines)
        this.redrawForLayer(layer);
    });
  }
  _getRoutePointIndexes(layer) {
    if (!layer._draggableLines) {
      return void 0;
    } else if (!layer._draggableLines.routePointIndexes) {
      const routePoints = layer.getDraggableLinesRoutePoints();
      if (!routePoints) {
        return void 0;
      }
      const latlngs = layer.getLatLngs();
      layer._draggableLines.routePointIndexes = locateOnLine(this._map, [latlngs], routePoints).map((r) => r.idx[1]);
    }
    return layer._draggableLines.routePointIndexes;
  }
}
Polyline.prototype.hasDraggableLinesRoutePoints = function() {
  if (this instanceof Rectangle) {
    return false;
  } else {
    return this.options.draggableLinesRoutePoints != null;
  }
};
Polyline.prototype.getDraggableLinesRoutePoints = function() {
  var _a;
  if (this instanceof Rectangle) {
    return void 0;
  } else {
    return (_a = this.options.draggableLinesRoutePoints) == null ? void 0 : _a.map((p) => latLng(p));
  }
};
Polyline.prototype.setDraggableLinesRoutePoints = function(routePoints) {
  if (this instanceof Rectangle) {
    return;
  } else {
    this.options.draggableLinesRoutePoints = routePoints;
    this.fire("draggableLines-setRoutePoints");
  }
};
const setLatLngsBkp = Polyline.prototype.setLatLngs;
Polyline.prototype.setLatLngs = function(...args) {
  const result = setLatLngsBkp.apply(this, args);
  this.fire("draggableLines-setLatLngs");
  return result;
};
export {
  DraggableLinesDragMarker,
  DraggableLinesMarker,
  DraggableLinesPlusMarker,
  DraggableLinesPlusTempMarker,
  DraggableLinesTempMarker,
  createDefaultMarkerIcon,
  createDefaultMarkerIconSrc,
  createSvgDataUrl,
  DraggableLinesHandler as default,
  defaultIcon,
  endIcon,
  getFromPosition,
  getPlusIconPoint,
  getRouteInsertPosition,
  insertAtPosition,
  locateOnLine,
  matchesLayerFilter,
  plusIcon,
  removeFromPosition,
  removePoint,
  setPoint,
  startIcon,
  updateAtPosition
};
//# sourceMappingURL=L.DraggableLines.js.map
